import { render, staticRenderFns } from "./FormChildDocs.vue?vue&type=template&id=ee700592&lang=pug&"
import script from "./FormChildDocs.vue?vue&type=script&lang=js&"
export * from "./FormChildDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports